import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ProductCard } from '../components/products/ProductCard';
import { getFeaturedProducts, categories } from '../data/products';
import { SEOHead } from '../components/SEOHead';
import { Breadcrumbs } from '../components/Breadcrumbs';

export default function GeschenkePage() {
  const featuredProducts = getFeaturedProducts();

  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]" data-testid="geschenke-page">
      <SEOHead
        title="Eid Geschenke für Familie, Kinder, Frauen & Männer"
        description="Handverlesene Eid Geschenke für jeden Anlass. Entdecke Geschenkideen für Kinder, Frauen, Männer und Familien zu Eid ul Fitr und Eid ul Adha."
        canonical="/geschenke"
      />
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-[#F5F5F0]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Breadcrumbs items={[{ label: 'Geschenke', path: '/geschenke' }]} />
          <div className="max-w-3xl mt-4">
            <span className="text-sm font-medium tracking-widest uppercase text-[#4A5D4F] mb-4 block">
              Alle Geschenke
            </span>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium text-[#2C332E] mb-6 leading-tight">
              Handverlesene{' '}
              <span className="text-[#4A5D4F] italic">Geschenkideen</span>
              {' '}für Eid
            </h1>
            <p className="text-lg md:text-xl text-[#6B7280] leading-relaxed">
              Entdecken Sie unsere sorgfältig ausgewählte Kollektion von Geschenken 
              für Eid ul Fitr und Eid ul Adha – für jeden in Ihrer Familie.
            </p>
          </div>
        </div>
      </section>

      {/* Categories Overview */}
      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E] mb-8">
            Nach Kategorie stöbern
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {categories.map((category) => (
              <Link
                key={category.id}
                to={`/geschenke/${category.id}`}
                data-testid={`category-link-${category.id}`}
                className="group p-6 rounded-2xl bg-white border border-[#E5E5E5] hover:border-[#4A5D4F] hover:shadow-lg transition-all duration-300"
              >
                <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-2 group-hover:text-[#4A5D4F] transition-colors">
                  {category.name}
                </h3>
                <p className="text-sm text-[#6B7280] mb-4 line-clamp-2">
                  {category.description}
                </p>
                <span className="inline-flex items-center text-sm font-medium text-[#4A5D4F] group-hover:gap-2 gap-1 transition-all duration-300">
                  {category.productCount} Geschenke
                  <ArrowRight className="w-4 h-4" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section className="py-16 md:py-20 bg-[#F5F5F0]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
            <div>
              <span className="text-sm font-medium tracking-widest uppercase text-[#4A5D4F] mb-4 block">
                Empfehlungen
              </span>
              <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">
                Unsere Top-Geschenke
              </h2>
            </div>
            <p className="text-[#6B7280] mt-4 md:mt-0 max-w-md">
              Besonders beliebte Geschenkideen, die von uns persönlich empfohlen werden.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {featuredProducts.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        </div>
      </section>

      {/* Trust Banner */}
      <section className="py-12 md:py-16 bg-[#4A5D4F]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <p className="text-white/90 text-lg md:text-xl font-medium">
            Sorgfältig ausgewählte Geschenkideen für Eid – getestet & empfohlen.
          </p>
        </div>
      </section>
    </main>
  );
}
